import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LogOut } from 'lucide-react';

export default function Header() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <header className="sticky top-0 z-40 backdrop-blur-xl bg-weave-cream/85 border-b border-weave-border">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
                    <img
                        src="/weave-logo.png"
                        alt="The Weave"
                        className="h-10 w-auto"
                        data-testid="weave-logo-img"
                    />
                    <span className="hidden sm:inline-block text-overline text-weave-ink-soft border-l border-weave-border pl-3">
                        1% Club · Funding Readiness
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm text-weave-ink-soft font-medium">
                    <NavLink
                        to="/check"
                        className={({ isActive }) =>
                            `hover:text-weave-teal transition ${isActive ? 'text-weave-teal' : ''}`
                        }
                        data-testid="nav-check"
                    >
                        Take the score
                    </NavLink>
                    <a href="/#how-it-works" className="hover:text-weave-teal transition" data-testid="nav-how">
                        How it works
                    </a>
                    <a href="/#membership" className="hover:text-weave-teal transition" data-testid="nav-membership">
                        Membership
                    </a>
                    {user && (
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                `hover:text-weave-teal transition ${isActive ? 'text-weave-teal' : ''}`
                            }
                            data-testid="nav-dashboard"
                        >
                            Dashboard
                        </NavLink>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <span className="hidden sm:inline text-sm text-weave-ink-soft">
                                Hi, {user.name.split(' ')[0]}
                            </span>
                            <button
                                onClick={() => {
                                    logout();
                                    navigate('/');
                                }}
                                className="text-weave-ink-soft hover:text-weave-red text-sm inline-flex items-center gap-1.5"
                                data-testid="header-logout-btn"
                            >
                                <LogOut className="w-4 h-4" />
                                <span className="hidden sm:inline">Log out</span>
                            </button>
                        </>
                    ) : (
                        <Link to="/check" data-testid="header-cta-check">
                            <button className="pill-btn bg-weave-red text-white hover:bg-weave-red-deep text-sm shadow-sm">
                                Check my score
                            </button>
                        </Link>
                    )}
                </div>
            </div>
        </header>
    );
}
